import { Button } from '@material-ui/core';
import { ALL_ACTIVE_COMPANIES } from '../../../../../../api/Routes';
import axios from 'axios';
import React, { useState, useEffect, Fragment } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const CompanyTable = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [visible, setVisible] = useState(false);

  const getAllCompanies = async () => {
    try {
      const response = await axios.get(ALL_ACTIVE_COMPANIES);
      setData(response.data);
    } catch (error) {
      setError(error);
    }
  };

  const handleTableVisibility = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    getAllCompanies();
  }, []);

  return (
    <Fragment>
      {data.length && visible ? (
        <Paper
          style={{ overflow: 'auto', maxHeight: '600px', marginBottom: '20px' }}
        >
          <Table>
            <TableHead
              style={{ background: 'white', position: 'sticky', top: 0 }}
            >
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell align="left">Company name</TableCell>
                <TableCell align="left">Address</TableCell>
                <TableCell align="left">Phone</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, idx) => (
                <TableRow key={idx + 'fsd'}>
                  <TableCell> {idx + 1} </TableCell>
                  <TableCell align="left">
                    {row.companyName ? row.companyName : ''}
                  </TableCell>
                  <TableCell align="left">
                    {row.address ? row.address : ''}
                  </TableCell>
                  <TableCell align="left">
                    {row.phone ? row.phone : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ) : null}
      <Button
        onClick={handleTableVisibility}
        variant="contained"
        color="primary"
      >
        {visible ? 'Hide ' : 'Show '} list of registered manufacturers
      </Button>
    </Fragment>
  );
};

export default CompanyTable;
